"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SamplingUnsupportedError = void 0;
exports.requestSampling = requestSampling;
class SamplingUnsupportedError extends Error {
    constructor() {
        super('MCP client does not support sampling (sampling/createMessage returned MethodNotFound)');
        this.name = 'SamplingUnsupportedError';
    }
}
exports.SamplingUnsupportedError = SamplingUnsupportedError;
async function requestSampling(server, messages, systemPrompt, maxTokens = 4096) {
    try {
        const result = await server.createMessage({ messages, systemPrompt, maxTokens });
        if (result.content.type !== 'text') {
            throw new Error(`Unexpected sampling result content type: ${result.content.type}`);
        }
        return result.content.text;
    }
    catch (error) {
        // MCP spec: MethodNotFound = -32601
        if (error?.code === -32601 ||
            error?.message?.includes('Method not found') ||
            error?.message?.includes('MethodNotFound')) {
            throw new SamplingUnsupportedError();
        }
        throw error;
    }
}
